<div class="status-management" [attr.data-automation-id]="modalAutomationId + '-container'">
    <res-top-nav-bar [isHomeButtonHidden]="true" [isProjectnameHidden]="true" [isRightMenuHidden]="true">
    </res-top-nav-bar>
    <div class="content">
        <div id="leftContent">
            <res-generic-tree #statusTree
                customClasses="generic-tree-navigation-header-panels generic-tree-header-panels-chevron-expanders generic-tree-header-panel-border-top generic-tree-border-bottom-left-radius"
                [automationId]="'status-tree'" [preselectNodeCallback]="preselectSettingCallback"
                [checkPermissions]="true">
            </res-generic-tree>
        </div>
        <res-resizer anchor="left" resizingElementId="leftContent" secondElementId="middleContent" [collapsible]="true"
            [initSize]="220" [minSize]="220" [maxSize]="220" collapsedIcon="fa-sitemap"
            collapsedTitle="Show Status Tree">
        </res-resizer>
        <div id="middleContent">
            <div id="navigationContent">
                <res-job-management *ngIf="this.selectedNode?.name === 'Job Management'"></res-job-management>
                <res-job-history *ngIf="this.selectedNode?.name === 'Job and Error History'"></res-job-history>
                <res-active-user-sessions *ngIf="this.selectedNode?.name === 'Active User Sessions'">
                </res-active-user-sessions>
                <res-project-access-history *ngIf="this.selectedNode?.name==='Project Access History'">
                </res-project-access-history>
                <res-system-audit-log *ngIf="this.selectedNode?.name === 'System Audit Log'"></res-system-audit-log>
                <res-monitoring *ngIf=" this.selectedNode?.name==='Monitoring'"></res-monitoring>
            </div>
        </div>
    </div>
</div>